import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';

import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import PopupPortal from 'apps/auth/components/common/Popup/PopupPortal';
import BasePage from 'apps/auth/components/utils/BasePage';
import { TOPUP_CARD_RESTRICTION_POPUP, TOPUP_CVV_POPUP } from 'apps/auth/constants/ComponentNames';
import { AMOUNT_TO } from 'apps/auth/constants/fieldsName';
import { TOP_UP_ACCOUNT } from 'apps/auth/constants/formName';

import TopUpCalc from './TopUpCalc';
import TopUpCardRestriction from '../popups/TopUpCardRestriction';
import TopUpCvvPopup from '../popups/TopUpCvvPopup';

const TopUpByCardCalcStep = (props) => {
    const [popup, setPopup] = useState('');
    const popupRef = useRef(null);

    const getPopupComponent = () => {
        if (popup === TOPUP_CARD_RESTRICTION_POPUP) {
            const icon = props.showUseAnotherAccount ? 'plus' : 'retry';
            return <TopUpCardRestriction icon={icon} popupRef={popupRef} setPopup={setPopup} />;
        }
        if (popup === TOPUP_CVV_POPUP) {
            return <TopUpCvvPopup formName={TOP_UP_ACCOUNT} popupRef={popupRef} />;
        }
    };

    const checkCardRestriction = () => {
        if (props.showUseAnotherAccount || props.showUseAnotherTopUpMethod) {
            setPopup(TOPUP_CARD_RESTRICTION_POPUP);
            popupRef.current?.open();
        } else {
            setPopup(TOPUP_CVV_POPUP);
            popupRef.current?.open();
        }
    };

    return (
        <>
            <CommonPage backUrl={`/auth/ga/pocket/${props.id}/top-up`} leftCloseIcon hasBottomPanel>
                <TopUpCalc
                    itemTitle={''}
                    formName={TOP_UP_ACCOUNT}
                    amount={props.amountFrom.value}
                    amountFieldName={AMOUNT_TO}
                    card={props.card}
                    sourceId={props.sourceId}
                />

                <FixedBottomPanel>
                    <Button
                        type="button"
                        raised={true}
                        onClick={checkCardRestriction}
                        disabled={props.amountFrom.isError || !props.amountFrom.value || parseFloat(props.amountFrom.value) === 0}
                        caption={props.cardTransferButton}
                    />
                </FixedBottomPanel>
            </CommonPage>
            <PopupNew ref={popupRef} getPopupComponent={getPopupComponent} as={PopupPortal} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        id: state.extra.id,
        sourceId: state.extra.sourceId,
        account: state.extra.account,
        card: state.extra.card,
        amountFrom: state.form[TOP_UP_ACCOUNT].fields[AMOUNT_TO],
        showUseAnotherAccount: state.extra.showUseAnotherAccount,
        showUseAnotherTopUpMethod: state.extra.showUseAnotherTopUpMethod,
        cardTransferButton: state.messages.pageMessages.cardTransferButton,
    };
};
export default connect(mapStateToProps, null)(BasePage(TopUpByCardCalcStep));
